import { useTheme } from '../../contexts/ThemeContext';
import { useLocale } from '../../contexts/LocaleContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { FONT_CONSTANTS } from '@/presentation/constants/fontConstants';

interface LogoTextComponentProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

export const LogoTextComponent = ({ size = 'large', color }: LogoTextComponentProps) => {
  const { theme } = useTheme();
  const { l10n } = useLocale();
  const { font } = useResponsiveDesign();
  const sizeFonts = {
    small: font['2xl'],
    medium: font['3xl'],
    large: font['5xl'],
  };

  return (
    <div className="flex justify-center">
      <h1
        className="tracking-normal"
        style={{ fontSize: sizeFonts[size], color: color ?? theme.exclusive, fontFamily: FONT_CONSTANTS.logoFamily }}
      >
        {l10n.common.logoText}
      </h1>
    </div>
  );
};
